export default ($stateProvider) => {
  $stateProvider
    .state('wrapper.answering-rule-list', {
      url: 'answering-rule-list',
      template: '<nets-answering-rule-list></nets-answering-rule-list>',
    });
};
